export default __webpack_public_path__ + "static/media/kids-playing.3084eed6.png";